export const VALIDATION_RULES = {
  full_name: {
    pattern: /^[A-Za-z\s'-]+$/,
    minLength: 2,
    message:
      'Please enter a valid Physician Name. Only letters and some special characters are allowed.',
    numberMessage:
      'Please enter a valid Physician Name. Numbers are not allowed.',
    lengthMessage: 'Physician name must be at least 2 characters long.',
  },
  unified: {
    pattern: /^[A-Za-z0-9\s/&-]+$/,
    minLength: 2,
    message:
      'Please enter a valid input. Only letters, numbers and some special characters are allowed.',
    lengthMessage: 'Input must be at least 2 characters long.',
  },
  common: {
    disallowedChars: /[!@#$%^*()_+=\[\]{};:'"`<>?\\|]/,
    message:
      'Please enter valid input. Some special characters are not allowed.',
  },
} as const

export const VALIDATION_MESSAGES = {
  PHYSICIAN: {
    full_name: VALIDATION_RULES.full_name.message,
    unified: VALIDATION_RULES.unified.message,
  },
  LOCATION: {
    INVALID_CHARS:
      'Please enter either a valid City, State Code (e.g., New York, NY) OR a 5-digit Zip code (e.g., 10013). Some special characters are not allowed.',
    INVALID_FORMAT:
      'Please enter either a valid City, State Code (e.g., New York, NY) OR a 5-digit Zip code (e.g., 10013)',
  },
} as const

export const DISALLOWED_LOCATION_CHARS = /[^a-zA-Z0-9\s,-]/
